import { Outlet, useNavigate } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { TopBar } from "./TopBar";
import { TopUpModal } from "@/components/billing/TopUpModal";
import { AuthDialog } from "@/components/auth/AuthDialog";
import { useAuthDialog } from "@/stores/authDialog";

export function AppLayout() {
  const navigate = useNavigate();
  const authDialog = useAuthDialog();
  return (
    <div className="min-h-[100dvh] flex">
      {/* «Пополнить баланс» ведёт на /billing#packs - блок с пакетами
          теперь сразу под KPI, кнопка «Купить» видна без скролла. */}
      <Sidebar onTopUp={() => navigate("/billing#packs")} />

      <div className="flex flex-1 min-w-0 flex-col">
        {/* Desktop-only top bar with language + theme; mobile pages render their own header */}
        <div className="hidden lg:flex h-14 items-center justify-end px-6 border-b border-line-soft bg-surface/40 backdrop-blur">
          <TopBar />
        </div>

        <main className="flex-1 min-w-0 overflow-x-hidden">
          <Outlet />
        </main>
      </div>
      <TopUpModal />
      {/* Глобальная модалка входа/регистрации — нужна гостю для апгрейда
          до полного аккаунта прямо из приложения. */}
      <AuthDialog
        open={authDialog.open}
        onOpenChange={authDialog.setOpen}
        defaultMode={authDialog.mode}
        onSuccess={() => navigate("/chat/new")}
      />
    </div>
  );
}
